import React, { ReactNode } from 'react';

import { Control, Path, useController } from 'react-hook-form';
import classNames from 'classnames';
import {
  TitleWithDescription,
  LbFormControlLabel,
  InfoBox,
  Radio,
} from '@infoods/lifebase-ui';

import classes from './SubscriptionOptionBox.module.scss';
import { SubscriptionType } from '../../../../../shared/constants/user-info/subscription';
import { BillingPeriodType } from '../../../../constants/billingPeriodType';
import { CreateSubscriptionFormValues } from '../../../../interfaces/createSubscription';

type SubscriptionOptionBox<TName extends Path<CreateSubscriptionFormValues>> = {
  control: Control<CreateSubscriptionFormValues>;
  optionValue: SubscriptionType | BillingPeriodType;
  name: TName;
  title: string;
  description: string;
  children: ReactNode;
};

//This component is used to choose a subscription type for nutrition subscriptions or billing period type for scan iq subscriptions
const SubscriptionOptionBox = <TName extends Path<CreateSubscriptionFormValues>>({
  control,
  optionValue,
  name,
  title,
  description,
  children,
}: SubscriptionOptionBox<TName>) => {
  const {
    field: { value, onChange },
  } = useController({
    control,
    name,
    rules: { required: 'Select type of subscription' },
  });

  const isSelected = value === optionValue;

  const boxClasses = classNames(classes.box, { [classes.selected]: isSelected });

  const Label = <TitleWithDescription title={title} description={description} />;

  const BoxTitle = (
    <LbFormControlLabel
      label={Label}
      control={
        <Radio
          checked={isSelected}
          onChange={() => {
            onChange(optionValue);
          }}
          color="primary"
        />
      }
      align="start"
    />
  );
  return (
    <InfoBox
      title={BoxTitle}
      variant="innerBox"
      hideConfig={{ show: isSelected }}
      className={boxClasses}
      customMargin
    >
      {children}
    </InfoBox>
  );
};

export { SubscriptionOptionBox };
